import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { ChevronContainer, Container, NavigationItem } from './css';
import NavigationSection from './navigationSection';
import ChevronIcon from '../../assets/icons/chevron_icon.svg';

class SecondaryNavigation extends PureComponent {
  render() {
    const { children } = this.props.fields.data.item;
    if (!children || children.length === 0) {
      return null;
    }

    const { id } = this.props.fields.data.contextItem;

    return (
      <Container>
        {
                    children.map((c, key) => {
                      if (c.template.name === 'Navigation-Section') {
                        return <NavigationSection key={key} id={key} section={c} contextItemId={id} />;
                      }

                      if (c.template.name === 'Navigation-Link') {
                        return (
                          <NavigationItem key={c.link} isActive={c.link.targetItem ? (c.link.targetItem.id === id) : false}>
                            <Link field={c.link.jss} to="#" />
                            <ChevronContainer>
                              <object type="image/svg+xml" data={ChevronIcon} aria-label={t('MoreOptions')} />
                            </ChevronContainer>
                          </NavigationItem>
                        );
                      }

                      return null;
                    },
                    )
                    }
      </Container>
    );
  }
}

SecondaryNavigation.propTypes = {
  fields: PropTypes.shape({
    data: PropTypes.shape({
      item: PropTypes.shape({
        children: PropTypes.array,
      }),
      contextItem: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }),
};

export default SecondaryNavigation;
